import Main from "./_main.es6";

const main = new Main();
